const TheaterIcon = ({ color1 = "#F4BFAE", color2 = "#EFA78C" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M1 6C1.55228 6 2 6.44772 2 7V17C2 17.5523 2.44772 18 3 18H13C13.5523 18 14 18.4477 14 19C14 19.5523 13.5523 20 13 20H2C1.46957 20 0.96101 19.7891 0.585938 19.4141C0.210865 19.039 0 18.5304 0 18V7C1.61065e-08 6.44772 0.447715 6 1 6ZM18 0C18.5304 2.20994e-07 19.039 0.210865 19.4141 0.585938C19.7891 0.96101 20 1.46957 20 2V14C20 14.5304 19.7891 15.039 19.4141 15.4141C19.039 15.7891 18.5304 16 18 16H6C5.46957 16 4.96101 15.7891 4.58594 15.4141C4.21087 15.039 4 14.5304 4 14V2C4 1.46957 4.21086 0.96101 4.58594 0.585938C4.96101 0.210865 5.46957 0 6 0H18ZM10.4961 4.85449C9.82948 4.47378 9 4.9559 9 5.72363V10.2764C9 11.0441 9.82948 11.5262 10.4961 11.1455L14.4805 8.86816C15.1523 8.48427 15.1523 7.51573 14.4805 7.13184L10.4961 4.85449Z"
        fill={color1}
        // fill-opacity="0.6"
      />
    </svg>
  );
};

export default TheaterIcon;
